import { useAuthStore } from '../stores';
let refreshInFlight = null;
export function getAccessTokenExpiryMs(accessToken) {
    try {
        const payload = accessToken.split('.')[1];
        if (!payload)
            return null;
        const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
        return typeof decoded.exp === 'number' ? decoded.exp * 1000 : null;
    }
    catch {
        return null;
    }
}
export async function refreshAccessToken() {
    if (refreshInFlight) {
        return refreshInFlight;
    }
    const { accessToken, refreshToken, updateTokens } = useAuthStore.getState();
    if (!accessToken || !refreshToken) {
        return null;
    }
    refreshInFlight = (async () => {
        try {
            const response = await fetch('/api/auth/refresh', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ accessToken, refreshToken }),
            });
            if (!response.ok) {
                return null;
            }
            const data = (await response.json());
            updateTokens(data.accessToken, data.refreshToken);
            return data.accessToken;
        }
        catch {
            return null;
        }
    })().finally(() => {
        refreshInFlight = null;
    });
    return refreshInFlight;
}
